<div class="page-container"
    [class.page-container--active]="stateService.isActive"
>
    <div class="page-container__wrapper">
        <ng-content></ng-content>
    </div>
</div>
